import { prettyBytes } from '@repo/lib/prettyBytes';
import { CloudUploadIcon, FileIcon } from 'lucide-react';

import type { DropzoneContentProps } from '.';

export function DropzoneContent(dropzoneContentProps: DropzoneContentProps) {
  const { maxFileSize } = dropzoneContentProps;
  return (
    <>
      <div aria-hidden={true} className="-z-10 mb-3 flex justify-center select-none">
        <div className="relative w-fit">
          <FileIcon className="stroke-muted-foreground size-14 stroke-1" />
          <span className="bg-gray absolute right-0 bottom-0 rounded-full p-1.5">
            <CloudUploadIcon className="text-gray-foreground size-3.5" />
          </span>
        </div>
      </div>
      <div className="block space-y-1 text-center select-none">
        <p className="text-accent-foreground text-sm">
          <em className="underline">Kliknij, aby przesłać</em> lub przeciągnij i upuść
        </p>
        {maxFileSize && <p className="text-muted-foreground text-xs">Maksymalny rozmiar pliku {prettyBytes(maxFileSize)}.</p>}
      </div>
    </>
  );
}
